<template>

    <div class="max-width-md-large m-auto pb-8">
        <MoonSpinner
            v-if="loading"
            :loading="true"
            container-size="160px"/>
        <div v-else class="d-flex md-d-block justify-content-between flex-column">

            <template v-if="error">

                <div class="py-6 md-py-3 mb-5 sm-mb-2 ">
                    <div class="progress-bar">
                        <div class="progress-bar-progress" style="width: 75%;"></div>
                        <div class="progress-bar-wrapper">
                            <div class="progress-bar-item" style="padding-left: 50%;">
                                <div class="progress-bar-step">
                                    <div class="progress-bar-indicator complete disabled"></div>
                                    <div class="mt-3 fw-bold c-mid-dark-grey c-minstead-green">Your donation</div>
                                </div>
                            </div>
                            <div class="progress-bar-item" style="padding-left: 50%;">
                                <div class="progress-bar-step">
                                    <div class="progress-bar-indicator complete disabled"></div>
                                    <div class="mt-3 fw-bold c-mid-dark-grey c-minstead-green">Your details</div>
                                </div>
                            </div>
                            <div class="progress-bar-item" style="padding-left: 50%;">
                                <div class="progress-bar-step">
                                    <div class="progress-bar-indicator disabled"></div>
                                    <div class="mt-3 fw-bold c-mid-dark-grey c-minstead-green">Payment</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="progress-bar-responsive m-top-3">
                        <div class="c-dark-grey">Step 3 out of 3</div>
                    </div>
                </div>

                <div class="card card--large card--green d-flex flex-column w-100">
                    <span class="fw-bold ml-auto mr-auto">There was an error setting up your regular donation via GoCardless</span>
                    <span class="mt-2 ml-auto mr-auto">You have not been charged at this time, please try again and if problems persist please contact us.</span>
                    <span class="mt-4 ml-auto mr-auto">Error: {{ error }}</span>
                </div>
            </template>

            <template v-if="!error">

                <div class="py-6 md-py-3 mb-5 sm-mb-2">
                    <div class="progress-bar">
                        <div class="progress-bar-progress" style="width: 100%;"></div>
                        <div class="progress-bar-wrapper">
                            <div class="progress-bar-item" style="padding-left: 50%;">
                                <div class="progress-bar-step">
                                    <div class="progress-bar-indicator complete disabled"></div>
                                    <div class="mt-3 fw-bold c-mid-dark-grey c-minstead-green">Your donation</div>
                                </div>
                            </div>
                            <div class="progress-bar-item" style="padding-left: 50%;">
                                <div class="progress-bar-step">
                                    <div class="progress-bar-indicator complete disabled"></div>
                                    <div class="mt-3 fw-bold c-mid-dark-grey c-minstead-green">Your details</div>
                                </div>
                            </div>
                            <div class="progress-bar-item" style="padding-left: 50%;">
                                <div class="progress-bar-step">
                                    <div class="progress-bar-indicator complete disabled"></div>
                                    <div class="mt-3 fw-bold c-mid-dark-grey c-minstead-green">Payment</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="progress-bar-responsive m-top-3">
                        <div class="c-dark-grey">Step 3 out of 3</div>
                    </div>
                </div>

                <div class="card card--large card--green w-100">
                    <h3 class="mb-3 sm-mb-2 text-center">Thank you!</h3>
                    <div class="fs-20 lh-13 sm-fs-18">
                        <div class="fw-light mb-3 sm-mb-2">
                            Thank you for your <span class="fw-bold">Monthly</span> donation of <span class="fw-bold">£{{ subscriptionAmount }}</span> to <span class="fw-bold">{{ subscription.name }}</span>.
                        </div>
                        <div class="fw-light mb-3 sm-mb-2">With the generosity of our supporters we can continue to give people with learning disabilities work skills and employment opportunities.</div>
                        <div class="fw-light">Please share your giving experience today and spread the word to others who may be able to help us in our work.</div>
                        <div class="d-flex w-100 mt-4 justify-content-center">
                            <add-this-share></add-this-share>
                        </div>
                    </div>
                </div>

            </template>

        </div>

    </div>

</template>

<script>

    import axios from 'axios';
    import MoonSpinner from "@/components/spinners/MoonSpinner";
    import Cookies from 'js-cookie';
    import AddThisShare from "../addthis-share/AddThisShare";

    export default {
        name: 'GocardlessRedirectFlowConfirmation',
        components: {MoonSpinner,AddThisShare},

        props: {
            redirectFlowId: {
                type: String,
                required: true
            },
            sessionToken: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                loading: true,
                meta: null,
                error: null,
                subscription: null
            }
        },

        computed: {
            subscriptionAmount() {
                let amount = this.subscription.amount / 100;
                return amount.toFixed(2);
            }
        },

        mounted() {
            this.getMetaData().then(()=>{
                return this.confirmRedirectFlow();
            }).then((redirectFlow)=>{
                return this.createSubscription(redirectFlow);
            }).then((subscription)=>{
                this.subscription = subscription;
                return this.storeSubscriptionMeta();
            }).then(()=>{
                this.loading = false;
            }).catch((error)=>{
                this.error = error.response.data.message;
                this.loading = false;
            });
        },

        methods: {

            getMetaData() {
                return new Promise(resolve=>{
                    this.meta = JSON.parse(Cookies.get(this.sessionToken));
                    return resolve();
                });
            },

            storeSubscriptionMeta() {

                this.error = null;
                return new Promise((resolve,reject)=>{
                    axios
                        .post(`/api/donations/gocardless/subscription/complete`, {
                            'id': this.subscription.id,
                            'data': this.meta
                        })
                        .then(({ data }) => {
                            return resolve(data);
                        })
                        .catch((error) => {
                            return reject(error);
                        });
                });

            },

            createSubscription(redirectFlow) {

                this.error = null;
                return new Promise((resolve,reject)=>{
                    axios
                        .post(`/api/donations/gocardless/subscription`, {
                            'name': redirectFlow.description,
                            'amount': redirectFlow.metadata.amount,
                            'mandate': redirectFlow.links.mandate,
                            'day_of_month': redirectFlow.metadata.day_of_month,
                            'interval_unit': redirectFlow.metadata.interval_unit,
                            'metadata' : {
                                'post_type': this.meta.post_type,
                                'post_id': this.meta.post_id,
                                'post_title': this.meta.donation_title ? this.meta.donation_title : this.meta.post_title,
                            }
                        })
                        .then(({ data }) => {
                            return resolve(data);
                        })
                        .catch((error) => {
                            return reject(error);
                        });
                });

            },

            confirmRedirectFlow() {

                this.error = null;
                return new Promise((resolve,reject)=>{
                    axios
                        .post(`/api/donations/gocardless/redirect-flow/complete`, {
                            'redirect_flow_id': this.redirectFlowId,
                            'session_token': this.sessionToken
                        })
                        .then(({ data }) => {
                            return resolve(data);
                        })
                        .catch((error) => {
                            return reject(error);
                        });
                });

            }

        }
    }

</script>
